import React, {useState} from 'react'
import { Suggestions } from './feed/suggestions'
import { Aboutus } from './feed/aboutus'
import { Aboutme } from './feed/aboutme'
import { AboutFeature } from './feed/aboutFeature'
import { Feature } from './feed/feature'
import { FeatureEdit } from './feed/featureEdit'
import { Projects } from './feed/projects'
import Navbar from '../../@shared/navigations/default'
import { Breadcrumbs } from './feed/breadcrumbs'
 
const ProfilePage = () =>{
    return( 
        <React.Fragment>
        <div>
           <Navbar />
           <Breadcrumbs />
           <div className="container2">
                <div>
                    <div><Aboutme  /></div>
                    <div>
                        <Aboutus  />
                        <AboutFeature />
                        <Feature />
                        <FeatureEdit />
                        <Projects />
                    </div>
                    
                </div>
            </div>
        </div>   
        </React.Fragment>
    )
}
 
 export default ProfilePage